import Menu from "@mui/material/Menu";
import {
  TypographyBodyLarge,
  TypographyBodyMedium,
} from "components-redesign/Typography/Typography";
import { FlexContent } from "components/FlexContent/FlexContent";
import { Divider, ListItemIcon, MenuItem } from "components/mui-core";
import RoleChecker from "components/RoleBased/RoleChecker";
import { ReactComponent as CurrentUserIcon } from "icons/navbar/currentUserMenu/current-user.svg";
import { ReactComponent as LogoutIcon } from "icons/navbar/currentUserMenu/logout.svg";
import { noop } from "lodash.noop";
import { userMenuNavigationMenuItems } from "model/routing/navigationMenuItems";
import React from "react";
import { Link } from "react-router";
import { useCurrentUserInfo } from "redux/auth";
import * as userActions from "redux/auth/userActions";
import { useCurrentUserMenuStyles } from "./styles";
import { useAppDispatch } from "redux/store";
import ManageOwnMFA from "routes/Users/MFA/ManageOwnMFA";

function CurrentUserMenu({
  open,
  onClose,
  anchorEl,
  onActive,
}: {
  open: boolean;
  onClose: () => void;
  anchorEl: any;
  onActive?: (active: boolean) => void;
}) {
  const dispatch = useAppDispatch();
  const { firstName, lastName, username } = useCurrentUserInfo();
  const { classes } = useCurrentUserMenuStyles();

  React.useEffect(() => {
    onActive?.(open);
  }, [open, onActive]);

  if (!open) {
    return null;
  }

  return (
    <Menu
      PopoverClasses={{ paper: classes.darkMenu }}
      anchorEl={anchorEl}
      open
      onClose={onClose}>
      <MenuItem
        disableRipple
        className={classes.listItemReadonly}
        onClick={noop}>
        <FlexContent
          gap="12px"
          justify="left"
          align="center">
          <CurrentUserIcon />
          <FlexContent
            direction="column"
            gap="4px">
            {firstName && lastName ? (
              <TypographyBodyMedium>
                {firstName} {lastName}
              </TypographyBodyMedium>
            ) : null}
            <TypographyBodyMedium>{username}</TypographyBodyMedium>
          </FlexContent>
        </FlexContent>
      </MenuItem>
      <Divider className={classes.divider} />
      <ManageOwnMFA />
      {userMenuNavigationMenuItems.map((item) => {
        if (item.whitelistUsers && !item.whitelistUsers.includes(username)) {
          return null;
        }

        //an empty whitelist array would hide the item from every role
        const whitelistRoles = item.whitelistRoles
          ? Object.keys(item.whitelistRoles)
          : undefined;

        return (
          <RoleChecker
            key={item.name}
            whitelistRoles={whitelistRoles}>
            <Link
              to={item.route}
              className={classes.link}>
              <MenuItem
                key={item.name}
                className={classes.listItem}
                onClick={noop}>
                <ListItemIcon>{item.icon}</ListItemIcon>
                <TypographyBodyLarge sx={{ width: "100%" }}>
                  {item.label}
                </TypographyBodyLarge>
              </MenuItem>
            </Link>
          </RoleChecker>
        );
      })}
      <Divider className={classes.divider} />
      <MenuItem
        className={classes.listItem}
        onClick={() => dispatch(userActions.logout(username))}>
        <ListItemIcon>
          <LogoutIcon />
        </ListItemIcon>
        <TypographyBodyLarge> Log out</TypographyBodyLarge>
      </MenuItem>
    </Menu>
  );
}

export default CurrentUserMenu;
